import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import "./filter-options-tenant.scss";
import { CustomCheckbox } from "../../../../common/components";
import { SubscriptionPlanFilterProps } from "./tenant-filter-helper";

const SubscriptionPlanFilter: React.FC<SubscriptionPlanFilterProps> = ({
  value,
  onChange,
  plans,
  label = "Select Plan",
  error,
  isMultiple = true,
}) => {
  return (
    <div className="tenant-filter-options-text-wrapper-select">
      <FormControl fullWidth error={!!error} size="small">
        <InputLabel className="subscription-label">{label}</InputLabel>
        <Select
          className="subscription-select"
          multiple={isMultiple}
          value={value}
          onChange={(e) =>
            onChange(
              typeof e.target.value === "string"
                ? [e.target.value]
                : e.target.value
            )
          }
          input={<OutlinedInput label={label} />}
          renderValue={(selected) =>
            Array.isArray(selected) ? selected.join(", ") : selected
          }
        >
          {plans.map((plan) => (
            <MenuItem
              key={plan}
              value={plan}
              className="subscription-menu-item"
            >
              <ListItemText primary={plan} />
              {isMultiple && (
                <CustomCheckbox
                  checked={value.includes(plan)}
                  onChange={() => {
                    const newValue = value.includes(plan)
                      ? value.filter((v) => v !== plan)
                      : [...value, plan];
                    onChange(newValue);
                  }}
                  label={""}
                />
              )}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </div>
  );
};

export default SubscriptionPlanFilter;
